// extracted by mini-css-extract-plugin
module.exports = {"container":"Result_container__2EbPB","highlight":"Result_highlight__1a80u"};